import { useEffect, useState } from 'react';
import { useGetUserQuery } from '~/services/user';

export default function useGetSalesTax() {
  const [salesTax, setSalesTax] = useState(0);
  const [formattedSalesTax, setFormattedSalesTax] = useState('N/A');
  const { data: rawUserData, isPending: isUserDataPending } = useGetUserQuery();

  useEffect(() => {
    if (rawUserData && !isUserDataPending) {
      const localSalesTax = rawUserData.locations?.[0]?.sales_tax ?? '';
      setSalesTax(localSalesTax);
      setFormattedSalesTax(localSalesTax ? `${localSalesTax}%` : 'N/A');
    }
  }, [rawUserData, isUserDataPending]);

  return { salesTax, formattedSalesTax };
}
